import { render, staticRenderFns } from "./MinAmountAlertModal.vue?vue&type=template&id=414bd746&"
import script from "./MinAmountAlertModal.vue?vue&type=script&lang=ts&"
export * from "./MinAmountAlertModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports